module.exports = __webpack_public_path__ + "img/mm.1809db77.svg";